// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"589":"9066dfccad45808c75dc","678":"1f782a451eaaaef86fb9","883":"a9e15508052a0946f174"}[chunkId] + ".js";
};